export enum FilterGroupType {
  Data = 'data',
  Events = 'events',
  Attributes = 'attributes',
}
